export { addGlobalEventProcessor, Scope } from './scope';
export { Session } from './session';
export { getActiveDomain, getCurrentHub, getHubFromCarrier, getMainCarrier, Hub, makeMain, setHubOnCarrier, } from './hub';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/kestutis/Projects/fifth-avenue/wp-content/themes/5th/node_modules/@sentry/hub/esm/index.js
// module id = 17
// module chunks = 0